"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BreadcrumbItem_component_exports = {};
__export(BreadcrumbItem_component_exports, {
  BreadcrumbItem: () => BreadcrumbItem,
  default: () => BreadcrumbItem_component_default
});
module.exports = __toCommonJS(BreadcrumbItem_component_exports);
var import_react = __toESM(require("react"));
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Breadcrumb = require("./Breadcrumb.styled");
var _excluded = ["isCurrentItem", "target", "showSeparator", "showSelectedValue", "cursor", "disabled", "darkMode", "variant"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var BreadcrumbItem = function BreadcrumbItem2(_ref) {
  var _ref$isCurrentItem = _ref.isCurrentItem, isCurrentItem = _ref$isCurrentItem === void 0 ? false : _ref$isCurrentItem, _ref$target = _ref.target, target = _ref$target === void 0 ? "_self" : _ref$target, _ref$showSeparator = _ref.showSeparator, showSeparator = _ref$showSeparator === void 0 ? true : _ref$showSeparator, _ref$showSelectedValu = _ref.showSelectedValue, showSelectedValue = _ref$showSelectedValu === void 0 ? false : _ref$showSelectedValu, _ref$cursor = _ref.cursor, cursor = _ref$cursor === void 0 ? "auto" : _ref$cursor, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "big" : _ref$variant, props = _objectWithoutProperties(_ref, _excluded);
  var defaultProps = {
    target,
    cursor,
    disabled,
    darkMode,
    variant
  };
  var getClassName = function getClassName2() {
    if (props.routerLink && props.NextLinkComponent) {
      return "breadcrumb-router-link";
    }
    if (props.nativeLink) {
      return "breadcrumb-native-link";
    }
    return "breadcrumb-item";
  };
  var getHrefValue = function getHrefValue2() {
    if (!disabled && !isCurrentItem) {
      if (props.NextLinkComponent) {
        return props.routerLink;
      }
      if (props.nativeLink) {
        return props.nativeLink;
      }
    }
    return void 0;
  };
  var getBreadcrumbAnchor = function getBreadcrumbAnchor2() {
    var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$activatorRef = _ref2.activatorRef, activatorRef = _ref2$activatorRef === void 0 ? null : _ref2$activatorRef, _ref2$listOpened = _ref2.listOpened, listOpened = _ref2$listOpened === void 0 ? void 0 : _ref2$listOpened, _ref2$toggleList = _ref2.toggleList, toggleList = _ref2$toggleList === void 0 ? void 0 : _ref2$toggleList, _ref2$selectedValue = _ref2.selectedValue, selectedValue = _ref2$selectedValue === void 0 ? void 0 : _ref2$selectedValue;
    var onItemClick = function onItemClick2(event) {
      if (event.target.getAttribute("disabled") !== null)
        event.preventDefault();
      if (toggleList) {
        toggleList();
      } else if (props.onSelectItem) {
        props.onSelectItem(props.children);
      }
    };
    if (activatorRef) {
      (0, import_useOnKeydown.useOnKeydown)(activatorRef, function(event) {
        var Enter = event.Enter;
        if (Enter) {
          activatorRef.current.click();
        }
      });
    }
    return /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumbAnchor, _extends({
      className: getClassName(),
      href: getHrefValue(),
      "aria-current": isCurrentItem ? "page" : void 0,
      "aria-haspopup": props.dropdownList ? "listbox" : void 0,
      "aria-expanded": listOpened,
      ref: activatorRef,
      onClick: onItemClick,
      linkColor: props.linkColor,
      currentItemColor: props.currentItemColor,
      textDecoration: props.textDecoration,
      textTransform: props.textTransform,
      tabIndex: props.dropdownList || disabled || isCurrentItem ? 0 : null,
      "data-dp-analytics-id": props.dataDpAnalyticsId,
      "aria-label": props.ariaLabel ? props.ariaLabel : props.children,
      role: "link",
      "aria-disabled": disabled
    }, defaultProps), props.icon && /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledIcon, {
      icon: props.icon,
      variant
    }), /* @__PURE__ */ import_react.default.createElement("span", null, showSelectedValue ? selectedValue : props.children), props.dropdownList && /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledIcon, {
      icon: listOpened ? "chevron-up" : "chevron-down",
      variant
    }));
  };
  var getBreadcrumbItemWithDropdown = function getBreadcrumbItemWithDropdown2() {
    return /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledDropdownContent, {
      activator: getBreadcrumbAnchor,
      list: props.dropdownList,
      selectedItem: showSelectedValue ? props.dropdownList[0] : void 0,
      customPositionOfPopover: {
        top: "-10px",
        right: "0px"
      },
      toggleItem: props.onSelectItem
    });
  };
  var getBreadcrumbItem = function getBreadcrumbItem2() {
    var breadcrumbAnchor = getBreadcrumbAnchor();
    if (props.readOnly) {
      return /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumParagraph, {
        variant,
        darkMode
      }, props.icon && /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledIcon, {
        icon: props.icon,
        variant
      }), props.children);
    }
    if (props.NextLinkComponent) {
      breadcrumbAnchor = /* @__PURE__ */ import_react.default.createElement(props.NextLinkComponent, {
        href: props.routerLink
      }, breadcrumbAnchor);
    }
    return breadcrumbAnchor;
  };
  return /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumbItem, _extends({
    className: props.className
  }, props), props.dropdownList && !props.readOnly ? getBreadcrumbItemWithDropdown() : getBreadcrumbItem(), showSeparator && /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledSeparator, {
    darkMode,
    variant,
    "aria-hidden": "true"
  }, "|"));
};
var BreadcrumbItem_component_default = BreadcrumbItem;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BreadcrumbItem
});
//# sourceMappingURL=BreadcrumbItem.component.js.map